import consts from "../../shared/consts"
import Completer from "./completer"
import { getNameFromAddress } from "./components/address-display"
import { getByte32List } from "./components/get-byte32-list"
import getCompiledMemoized from "./components/getCompiled"
import { StepResultTable } from "./components/step-result-table"
import { downloader } from "./downloader"
import { getEndPoint } from "./utils/endpoint"
import {
  getLibraryURL,
  getSimulationURL,
} from "./utils/get-simulation-library-url"
import { isValidAddress, isValidBytes32 } from "./utils/is-valid-address"
import { navigate } from "./utils/react-utils"
import { invalidateCache, requestJSON } from "./utils/request-module"

var { newStore } = require("./utils/store-creator")
var store = newStore({
  isAdmin: false,
  hasEngagementManagerAccess: false,
  name: "",
  isSaving: false,
  saved: false,
  description: "",
  environment: "MAINNET",
  network: "mainnet",
  blockNumber: null,
  viewOrEdit: "edit",
  isReadOnly: false,
  isLoadingResults: false,
  blockNumberMode: undefined,
  currentStoryId: 0,
  currentResult: 0,
  templates: [],
  allMyReviews: [],
  myReviews: [],
  pinnedReviews: [],
  ciReviews: [],
  allAnalytics: [],
  showEditReviewFileModal_reviewId: null,
  showEditReviewFileModal_completer: Completer(),
  showReanalyzeConfirmationModal: false,
  showEnterSimulationNameModal: false,
  openEnterSimulationNameModal: () => {
    store.showEnterSimulationNameModal = true
    store.updateStore()
  },
  closeEnterSimulationNameModal: () => {
    store.showEnterSimulationNameModal = false
    store.updateStore()
  },
  openReanalyzeConfirmationModal: () => {
    store.showReanalyzeConfirmationModal = true
    store.updateStore()
  },
  closeReanalyzeConfirmationModal: () => {
    store.showReanalyzeConfirmationModal = false
    store.updateStore()
  },
  analyze: async (review_id) => {
    try {
      let url = "/sc_analyzer/analyze"
      let body = {
        review_id: review_id,
      }
      return await requestJSON("POST", url, body)
    } catch (err) {
      console.log("Some error has occured while copying from template ", err)
    }
  },

  getSimulationUsingAIJSON: async () => {
    try {
      let url = "/simulation/create-simulation-using-AI"
      let body = {
        id: store.selectedSimulationData._id,
      }
      let response = await requestJSON("POST", url, body)
      return response
    } catch (err) {
      console.log(
        "Some error has occured while creating simulation using AI ",
        err,
      )
    }
  },
  showEditReviewFileModal: async function (review_id) {
    var completer = Completer()
    store.showEditReviewFileModal_reviewId = review_id
    store.showEditReviewFileModal_completer = completer
    store.updateStore()
    await completer.promise
    store.showEditReviewFileModal_reviewId = null
    store.updateStore()
    store.invalidateReviewAbiCache(review_id)
  },
  analytics: [],
  analyticsFilter: {
    startDate: require("moment")().format("YYYY-MM-DD"),
    endDate: require("moment")().format("YYYY-MM-DD"),
    organization: "All",
    engagement: "All",
    review: "All",
    user: "All",
    operation: "All",
  },
  logout: () => {
    var iframe = document.createElement("iframe")
    iframe.src = "https://dev-blockchain-ey.auth0.com/v2/logout"
    document.body.appendChild(iframe)
    setTimeout(() => {
      window.open(getEndPoint() + "/logout", "_top")
    }, 1000)
  },
  auth_error: "",
  allEngagements: [],
  engagements: [],
  userEngagements: [],
  organizations: [],
  userOrganizations: [],
  favSimulationIds: [],
  toaster: {
    open: false,
    variant: null,
    message: "",
  },

  preFetchedReviewId: "",
  simulationMetadataLoading: false,
  simulationMaindataLoading: false,
  selectedSimulationMaindataLoading: false,
  simulationMaindata: {},

  defaultSimulationData: {},
  allSimulations: [],
  simulations: [],
  defaultSimulationsStepCount: 0,
  isDefaultSimulation: true,
  simulationCounts: {
    all: 0,
    mySimulations: 0,
    myFavorites: 0,
  },
  simulationFilter: {
    searchText: "",
    function: "All",
    creator: "All",
    passExpections: "All",
    template: "All",
    sortBy: "Created",
    simulationType: "All",
  },
  myReviewFilter: {
    engagementId: "All",
  },
  engagementManagerFilter: {
    orgId: "All",
  },
  isReviewAllowed: false,
  currentReviewId: "",
  simulationReviewId: "",
  selectedReviewData: {},
  loadingSolidityCompilerVersions: false,
  solidityCompilerVersions: [],
  selectedSimulationList: {},
  creatingNewSimulation: false,
  pinUnpinInfoShowed: false,
  isTemplateReview: false,
  updateByte32List: () => {
    // Getting the byte32 list from the code using regex.
    // Then comparing with selected simulation byte32 list
    // If the property is not present just adding the the byte32 list in DB.
    // If the property is present then checking if any byte32 hash that is not present in selected simulation byte32 list.
    // Then creating a new list with all the byte32 new and old and update the list in DB 

    let byte32List = getByte32List()
    if (!store.selectedSimulationData["byte32List"]) {
      updateByte32ListInDB()
    } else {
      let byte32ListIsEqual = require("lodash").isEqual(
        byte32List,
        store.selectedSimulationData["byte32List"],
      )
      if (!byte32ListIsEqual) {
        byte32List = require("lodash").assign({}, byte32List, store.selectedSimulationData["byte32List"]);
        updateByte32ListInDB()
      }
    }
    function updateByte32ListInDB() {
      store.selectedSimulationData["byte32List"] = byte32List
      store.updateStore()
      store.updateSimulationMetadataProperty(
        "byte32List",
        byte32List,
        store.selectedSimulationData._id,
      )
      store.updateSimulationMaindataProperty(
        "byte32List",
        byte32List,
        store.selectedSimulationData._id,
      )
    }
  },
  selectAllSimulations: () => {
    for (let i = 0; i < store.simulations.length; i++) {
      if (!store.selectedSimulationList[store.simulations[i]["_id"]]) {
        store.selectedSimulationList[store.simulations[i]["_id"]] = true
      }
    }
    store.updateStore()
  },
  deSelectAllSimulations: () => {
    store.selectedSimulationList = {}
    store.updateStore()
  },
  updateSimulationFilter: (fieldName, value) => {
    store.simulationFilter[fieldName] = value

    store.simulations = JSON.parse(JSON.stringify(store.allSimulations))

    if (store.simulationFilter.searchText) {
      store.simulations = store.simulations.filter((item) => {
        if (
          item.name
            .toLowerCase()
            .indexOf(store.simulationFilter.searchText.toLowerCase().trim()) >=
          0
        ) {
          return true
        } else {
          return false
        }
      })
    }

    if (store.simulationFilter.function != "All") {
      store.simulations = store.simulations.filter(
        (simulation) =>
          !!simulation.functionsInUse.find(
            (func) => func.name === store.simulationFilter.function,
          ),
      )
    }

    if (store.simulationFilter.creator != "All") {
      store.simulations = store.simulations.filter((item) => {
        if (item.userName == store.simulationFilter.creator) {
          return true
        } else {
          return false
        }
      })
    }

    if (store.simulationFilter.passExpections != "All") {
      store.simulations = store.simulations.filter((item) => {
        if (
          item.pass_expections ==
          (store.simulationFilter.passExpections == "Pass")
        ) {
          return true
        } else {
          return false
        }
      })
    }

    if (store.simulationFilter.template != "All") {
      store.simulations = store.simulations.filter((item) => {
        if (item.template_id == store.simulationFilter.template) {
          return true
        } else {
          return false
        }
      })
    }

    if (store.simulationFilter.simulationType != "All") {
      if (store.simulationFilter.simulationType == "Attached to task") {
        store.simulations = store.simulations.filter((item) => {
          if (item["task_id"]) {
            return true
          } else {
            return false
          }
        })
      }

      if (store.simulationFilter.simulationType == "Not attached to task") {
        store.simulations = store.simulations.filter((item) => {
          if (!item["task_id"]) {
            return true
          } else {
            return false
          }
        })
      }
    }

    store.sortSimulationList()
    store.unselectNotVisibleSimulations()
    store.updateStore()
  },
  unselectNotVisibleSimulations: () => {
    let visibleSimulationIds = {}

    for (let i = 0; i < store.simulations.length; i++) {
      visibleSimulationIds[store.simulations[i]["_id"]] = true
    }

    let selectedSimulationListArr = Object.keys(store.selectedSimulationList)

    for (let i = 0; i < selectedSimulationListArr.length; i++) {
      if (!visibleSimulationIds[selectedSimulationListArr[i]]) {
        delete store.selectedSimulationList[selectedSimulationListArr[i]]
      }
    }
  },
  removeResults: (stepIndex = 0) => {
    if (!store.results?.[0]) return
    let stepOutput = JSON.parse(JSON.stringify(store.results[0].steps_output))
    stepOutput.splice(stepIndex, stepOutput.length - stepIndex)
    store.results[0].steps_output = stepOutput
    store.results[0].pass_expections = null
    store.updateStore()
  },
  sortSimulationList: () => {
    switch (store.simulationFilter.sortBy) {
      case "Name":
        return sortSimulationByName()
      case "Created":
        return sortSimulationByDateCreated()
      case "Modified":
        return sortSimulationByDateModified()
    }

    function sortSimulationByName() {
      let sortProp = "name"
      store.simulations.sort((simA, simB) => {
        if (!simA || !simB || !simA[sortProp] || !simB[sortProp]) {
          return 0
        }
        if (simA[sortProp].toLowerCase() < simB[sortProp].toLowerCase()) {
          return -1
        }
        if (simA[sortProp].toLowerCase() > simB[sortProp].toLowerCase()) {
          return 1
        }
        return 0
      })
    }

    function sortSimulationByDateCreated() {
      let sortProp = "created"
      store.simulations.sort((simA, simB) => {
        if (simA[sortProp] > simB[sortProp]) {
          return -1
        }
        if (simA[sortProp] < simB[sortProp]) {
          return 1
        }
        return 0
      })
    }

    function sortSimulationByDateModified() {
      let sortProp = "modified"
      store.simulations.sort((simA, simB) => {
        if (simA[sortProp] > simB[sortProp]) {
          return -1
        }
        if (simA[sortProp] < simB[sortProp]) {
          return 1
        }
        return 0
      })
    }
  },
  resetAllFiltersAndSorting: () => {
    store.updateSimulationFilter("searchText", "")
    store.updateSimulationFilter("function", "All")
    store.updateSimulationFilter("creator", "All")
    store.updateSimulationFilter("passExpections", "All")
    store.updateSimulationFilter("template", "All")
    store.updateSimulationFilter("sortBy", "Created")
  },

  updateMyReviewFilter: (fieldName, value) => {
    store.myReviewFilter[fieldName] = value
    store.setMyReviewFilterLocalStorage(store.myReviewFilter)
    store.myReviews = JSON.parse(JSON.stringify(store.allMyReviews))

    if (store.myReviewFilter.engagementId != "All") {
      store.myReviews = store.myReviews.filter((item) => {
        if (item.engagementData.engId == store.myReviewFilter.engagementId) {
          return true
        } else {
          return false
        }
      })
    }
    store.updateStore()
  },

  resetMyReviewFilter: async () => {
    store.updateMyReviewFilter("engagementId", "All")
    await store.updateMyReviewList()
    await store.fetchUserEngagements()
  },

  setMyReviewFilterLocalStorage: (filterObj) => {
    localStorage.setItem("myReviewFilter", JSON.stringify(filterObj))
  },

  getMyReviewFilterLocalStorage: () => {
    return localStorage.getItem("myReviewFilter")
  },

  checkAndSetMyReviewFilter: () => {
    let filterObjStr = store.getMyReviewFilterLocalStorage()
    if (filterObjStr) {
      let filterObj = JSON.parse(filterObjStr)
      if (filterObj["engagementId"] && store.allMyReviews.length) {
        store.myReviewFilter = filterObj
        store.updateMyReviewFilter("engagementId", filterObj.engagementId)
        store.updateStore()
      }
    }
  },

  updateEngagementManagerFilter: (fieldName, value) => {
    store.engagementManagerFilter[fieldName] = value
    store.setEngagementManagerFilterLocalStorage(store.engagementManagerFilter)
    store.engagements = JSON.parse(JSON.stringify(store.allEngagements))

    if (store.engagementManagerFilter.orgId != "All") {
      store.engagements = store.engagements.filter((item) => {
        if (item.orgId == store.engagementManagerFilter.orgId) {
          return true
        } else {
          return false
        }
      })
    }
    store.updateStore()
  },

  resetEngagementManagerFilter: () => {
    store.updateEngagementManagerFilter("orgId", "All")
    store.updateEngagementList()
    store.fetchUserOrganizations()
  },

  setEngagementManagerFilterLocalStorage: (filterObj) => {
    localStorage.setItem("engagementManagerFilter", JSON.stringify(filterObj))
  },

  getEngagementManagerFilterLocalStorage: () => {
    return localStorage.getItem("engagementManagerFilter")
  },

  checkAndSetEngagementManagerFilter: () => {
    let filterObjStr = store.getEngagementManagerFilterLocalStorage()
    if (filterObjStr) {
      let filterObj = JSON.parse(filterObjStr)
      if (filterObj["orgId"] && store.allEngagements.length) {
        store.engagementManagerFilter = filterObj
        store.updateEngagementManagerFilter("orgId", filterObj.orgId)
        store.updateStore()
      }
    }
  },

  fetchSelectedReviewData: async () => {
    store.selectedReviewData = await store.fetchOneReview(qs().review_id)
    store.updateStore()
  },

  updateAnalyticsFilter: async (fieldName, value) => {
    store.analyticsFilter[fieldName] = value

    store.analytics = JSON.parse(JSON.stringify(store.allAnalytics))

    if (store.analyticsFilter.startDate && store.analyticsFilter.endDate) {
      await store.fetchtAnalytics({
        start_date: store.analyticsFilter.startDate,
        end_date: store.analyticsFilter.endDate,
      })
    }

    if (store.analyticsFilter.organization != "All") {
      store.analytics = store.analytics.filter((item) => {
        if (
          item["organizationData"] &&
          item.organizationData.name == store.analyticsFilter.organization
        ) {
          return true
        } else {
          return false
        }
      })
    }

    if (store.analyticsFilter.engagement != "All") {
      if (store.analyticsFilter.engagement == "Public") {
        store.analytics = store.analytics.filter((item) => {
          if (!item.engagement_id) {
            return true
          } else {
            return false
          }
        })
      } else {
        store.analytics = store.analytics.filter((item) => {
          if (item.engagement_id) {
            return true
          } else {
            return false
          }
        })
      }
    }

    if (store.analyticsFilter.review != "All") {
      store.analytics = store.analytics.filter((item) => {
        if (item.review_name == store.analyticsFilter.review) {
          return true
        } else {
          return false
        }
      })
    }

    if (store.analyticsFilter.user != "All") {
      store.analytics = store.analytics.filter((item) => {
        if (item["user_email"] == store.analyticsFilter.user) {
          return true
        } else {
          return false
        }
      })
    }

    if (store.analyticsFilter.operation != "All") {
      store.analytics = store.analytics.filter((item) => {
        if (item["operation"] == store.analyticsFilter.operation) {
          return true
        } else {
          return false
        }
      })
    }

    store.updateStore()
  },
  clearAnalyticsFilter: () => {
    store.analyticsFilter = {
      startDate: require("moment")().format("YYYY-MM-DD"),
      endDate: require("moment")().format("YYYY-MM-DD"),
      organization: "All",
      engagement: "All",
      review: "All",
      user: "All",
      operation: "All",
    }
    store.fetchtAnalytics({
      start_date: require("moment")().format("YYYY-MM-DD"),
      end_date: require("moment")().format("YYYY-MM-DD"),
    })

    store.updateStore()
  },
  getLineNoFromCharacterNo: (text, src) => {
    let offset = Number(src.split(":")[1])
    let lineNum = 0
    let charCount = 0
    for (let line of text) {
      charCount += line.length + 1
      if (charCount > offset) {
        return lineNum
      }
      lineNum++
    }
  },
  getLineContentFromSourceMap: (simplifierContent, src) => {
    let lineNumber = store.getLineNoFromCharacterNo(simplifierContent, src)
    let contentInSimplified = simplifierContent
      .replace(/\/\/.*/g, "")
      .split("\n")
      [lineNumber - 1].trim()
    return contentInSimplified
  },
  getContentFromSimlified: (simplifierContent, lineNumber) => {
    let content = ""
    content = simplifierContent.split("\n")[lineNumber - 1].trim()
    return content
  },
  // search function takes object as a first param and
  // a predicate Function as second predicate(key, value) => boolean
  deepSearchJSON: (obj = {}, key, value) => {
    const result = []
    const recursiveSearch = (obj = {}) => {
      if (!obj || typeof obj !== "object") {
        return
      }
      if (obj[key] === value) {
        result.push(obj)
      }
      Object.keys(obj).forEach(function (k) {
        recursiveSearch(obj[k])
      })
    }
    recursiveSearch(obj)
    return result
  },
  updateAbi: async (stepIndex) => {
    if (store.steps[stepIndex].using_review_files) {
      try {
        store.steps[stepIndex].abiLoadingStatus = "loading"
        store.updateStore()
        let { abi, bytecode } = await store.getReviewFilesAbiAndByteCode(false)
        store.steps[stepIndex].abi = abi
        store.steps[stepIndex].abiLoadingStatus = "ready"
        store.abiABiUseUsingIt(stepIndex)
        store.updateStore()
      } catch (err) {
        store.steps[stepIndex].abiLoadingStatus = "error"
        store.updateStore()
        console.log("Some error has occured while fetching review abi ", err)
      }
    } else {
      await store.compileStepFilesChanged(stepIndex)
    }
  },
  loadSolidityCompilerVersions: async () => {
    store.loadingSolidityCompilerVersions = true
    store.updateStore()
    try {
      let compilerList = await requestJSON(
        "GET",
        "/get_solidity_compilers",
        undefined,
        true,
      )
      store.solidityCompilerVersions = compilerList.solidityCompilers
    } catch (err) {
      console.log("Some error has occured while fetching review abi ", err)
    } finally {
      store.loadingSolidityCompilerVersions = false
      store.updateStore()
    }
  },
  clearOneSimulationData: () => {
    store.currentStoryId = 0
    store.selectedSimulationData = {}
    store.isDefaultSimulation = false
    store.results = []
    store.steps = []
    store.isMainnet = false
    store.blockNumber = null
    store.updateStore()
  },
  selectedSimulationData: {},
  // This is filled from db. It should be private no one should read it.
  selectedSimulationAddressList: [],
  selectedSimulationByte32List: [],
  _lastList: {},
  // This is what everyone is using
  getSelectedSimulationAddressListObj: () => {
    // crete the dynamic list from all the steps. It should not be in the DB
    var addressWithAutoGeneratedName = getDynamicAddressList()

    // This is address that have names should be saved in db
    var addressWithNamesByUser = store.selectedSimulationAddressList

    function getDynamicAddressList() {
      // Go over all deployments steps and add addresses that do not have names.
      // Add it to the dynamic so users can choose is later.
      // If the address not in use any more it should not appear any more.
      // This is why we do not save it in the DB

      // Here we start by adding addresses of current deployed contracts
      var list = {}
      var counter = -1
      for (let step of store.steps) {
        counter++
        if (step.type=='COMPILE_SMART_CONTRACT') {
          list[
            '0x000000000000000000000000000000000000000' + (counter+1)
          ] = "Deployed at step " + (counter + 1)
        }
      }
      // // Here we adding address in use that do not have a name yet
      for (let step of store.steps) {
        if (
          step.to &&
          list[step.to] === undefined && // add to the list only if it does not have a name
          isValidAddress(step.to)
        ) {
          list[step.to] = ""
        }

        if (
          step.from &&
          list[step.from] === undefined &&
          isValidAddress(step.from)
        ) {
          list[step.from] = ""
        }

        // eslint-disable-next-line no-prototype-builtins
        if (step.hasOwnProperty("parameters") && step.parameters.length) {
          for (let i = 0; i < step.parameters.length; i++) {
            if (Array.isArray(step.parameters[i])) {
              for (let j = 0; j < step.parameters[i].length; j++) {
                if (
                  isValidAddress(step.parameters[i][j]) &&
                  list[step.parameters[i][j]] === undefined
                ) {
                  list[step.parameters[i][j]] = ""
                }
              }
            } else if (
              typeof step.parameters[i] == "string" &&
              isValidAddress(step.parameters[i]) &&
              list[step.parameters[i]] === undefined
            ) {
              list[step.parameters[i]] = ""
            }
          }
        }
      }

      return list
    }

    // Go over all fields without a name and fetch from server.
    // We don't have the result yet (it's a promise).
    // So save the promise and later add it to the DB
    // After it will be added to the DB:
    // 1. The store will be updated.
    // 2. The components will be rendered.
    // 3. This whole functions will be called again.
    // 4. Now it will not fetched from remote since it is in the DB already.

    var promises = []
    for (let step of store.steps) {
      if (
        step.to && // We only support "TO" since we only have names of smart contracts and they must appear in the TO address
        isValidAddress(step.to) &&
        !addressWithNamesByUser[step.to] // Do not add it twice if in several steps
      ) {
        var thisPromise = getNameFromAddress(step.to) // We can't use await. JSX will not wait for promises
        thisPromise.then((name) => {
          // When we have a name add it to the DB object. No need to save it remotely.
          // After page refresh it can be called again to add it again to the DB object.
          if (name) {
            // It will be saved in db
            addressWithNamesByUser[step.to] = name
          }
        })

        // We want to refresh the store when this promise finished.
        // And we fetched everything
        promises.push(thisPromise)
      }
    }

    if (promises.length > 0) {
      Promise.all(promises).then(() => {
        // After we fetched all the names remotly. We need to update the store.
        var objStringify = JSON.stringify({
          ...addressWithAutoGeneratedName, // We must start with the dynmaic list. The dynamic list might have names like "", and they will override real names from the names by user
          ...addressWithNamesByUser,
        })
        if (store._lastList == objStringify) {
          // We don't wan't to update the store, if there is no change to the list.
          return
        }
        store._lastList = objStringify
        store.updateStore()
      })
    }

    // We return every this. Before fetched completed.
    return {
      ...addressWithAutoGeneratedName, // We must start with the dynaic list. The static list might have names like "", and they will override real names
      ...addressWithNamesByUser,
    }
  },

  getSelectedSimulationByte32ListObj: () => {
    let byte32WithAutoGeneratedName = getDynamicByte32List();
    let byte32WithNamesByUser = store.selectedSimulationByte32List;

    function getDynamicByte32List() {
      let list = {}
      for (let step of store.steps) {
        // eslint-disable-next-line no-prototype-builtins
        if (step.hasOwnProperty("parameters") && step.parameters.length) {
          for (let i = 0; i < step.parameters.length; i++) {
            if (Array.isArray(step.parameters[i])) {
              for (let j = 0; j < step.parameters[i].length; j++) {
                if (
                  isValidBytes32(step.parameters[i][j]) &&
                  list[step.parameters[i][j]] === undefined
                ) {
                  list[step.parameters[i][j]] = ""
                }
              }
            } else if (
              typeof step.parameters[i] == "string" &&
              isValidBytes32(step.parameters[i]) &&
              list[step.parameters[i]] === undefined
            ) {
              list[step.parameters[i]] = ""
            }
          }
        }
      }

      return list
    }

    var promises = []

    if (promises.length > 0) {
      Promise.all(promises).then(() => {
        // After we fetched all the names remotly. We need to update the store.
        var objStringify = JSON.stringify({
          ...byte32WithAutoGeneratedName, // We must start with the dynmaic list. The dynamic list might have names like "", and they will override real names from the names by user
          ...byte32WithNamesByUser,
        })
        if (store._lastList == objStringify) {
          // We don't wan't to update the store, if there is no change to the list.
          return
        }
        store._lastList = objStringify
        store.updateStore()
      })
    }

    // We return every this. Before fetched completed.
    return {
      ...byte32WithAutoGeneratedName, // We must start with the dynaic list. The static list might have names like "", and they will override real names
      ...byte32WithNamesByUser,
    }
  },
  getUpdateSimulationURL: () => {
    let editPriority =
      window["config"].EDIT_PRIORITY === "true" ||
      window["config"].EDIT_PRIORITY === true
    return (
      "/simulations?" +
      require("qs").stringify({
        q: qs().q,
        tag: qs().tag,
        favorites: qs().favorites,
        organization: qs().organization,
        engagement_id: qs().engagement_id,
        review_id: qs().review_id,
        includeStepsResult: false,
        editPriority: editPriority,
      })
    )
  },
  userIsAllowed: (user) => {
    return user === store.selectedSimulationData.user || store.selectedSimulationData.createdByEmail || qs().review_id
  },
  invalidateReviewAbiCache: async (review_id) => {
    if (review_id) {
      await invalidateCache(
        "GET",
        "/simulation/review-abi/" + review_id,
        undefined,
      )
    }
  },
  invalidateReviewData: async (review_id) => {
    if (review_id) {
      await invalidateCache(
        "GET",
        "/review/my-review/" + review_id,
        undefined,
      )
    }
  },
  getReviewFilesAbiAndByteCode: async (useCache = true) => {
    try {
      let { abi, bytecode } = await requestJSON(
        "GET",
        "/simulation/review-abi/" + qs().review_id,
        undefined,
        useCache,
      )
      return { abi, bytecode }
    } catch (err) {
      console.log("Some error has occured while fetching review abi ", err)
    }
  },
  inValidateSimulationList: () => {
    throw new Error(
      "you do not need to call it, instead change the store.simulations array",
    )
  },
  lastUserFetched: "",

  fetchSimulationListMetadata: async (forceUpdate = false) => {
    if (
      !forceUpdate &&
      qs().review_id &&
      store.preFetchedReviewId == qs().review_id?.toString()
    ) {
      return
    }

    store.simulationMetadataLoading = true
    store.preFetchedReviewId = qs().review_id?.toString()
    store.allSimulations = []
    store.simulations = []
    store.updateStore()

    let url =
      "/simulations-metadata?" +
      require("qs").stringify({
        organization: qs().organization,
        review_id: qs().review_id,
      })

    try {
      let simulationListMetadataResponse = await requestJSON(
        "GET",
        url,
        undefined,
        false,
      )
      store.allSimulations = simulationListMetadataResponse
      store.simulations = simulationListMetadataResponse
    } catch (err) {
      console.log(
        "Some error has occured while fetching simulationslist metadata ",
        err,
      )
    } finally {
      store.simulationMetadataLoading = false
      store.updateStore()
    }
  },

  fetchSimulationMaindata: async () => {
    if (store.simulationMetadataLoading || !store.allSimulations.length) {
      return
    }

    store.simulationMaindataLoading = true
    store.simulationMaindata = {}
    store.updateStore()

    for (let i = 0; i < store.allSimulations.length; i++) {
      if (!store.simulationMaindata[store.allSimulations[i]["_id"]]) {
        try {
          let simulationData = await requestJSON(
            "GET",
            "/simulation/" + store.allSimulations[i]["_id"],
          )
          store.simulationMaindata[store.allSimulations[i]["_id"]] =
            simulationData
          store.updateStore()
        } catch (err) {
          console.log(
            "Some error has occured while fetching one simulation main data ",
            err,
          )
        }
      }
    }

    store.simulationMaindataLoading = false
    store.updateStore()
  },

  getSelectedSimulationMainData: async (id) => {
    if (store.simulationMaindata[id]) {
      return store.simulationMaindata[id]
    }
    try {
      let simulationData = await requestJSON("GET", "/simulation/" + id)
      store.simulationMaindata[id] = simulationData
      store.updateStore()
      return simulationData
    } catch (err) {
      console.log(
        "Some error has occured while fetching one simulation main data ",
        err,
      )
    }
  },
  updateSimulationMetadataProperty: (
    propertyKey,
    propertyValue,
    simulationId,
  ) => {
    for (let i = 0; i < store.simulations.length; i++) {
      if (store.simulations[i]["_id"] == simulationId) {
        store.simulations[i][propertyKey] = propertyValue
        break
      }
    }
    for (let i = 0; i < store.allSimulations.length; i++) {
      if (store.allSimulations[i]["_id"] == simulationId) {
        store.allSimulations[i][propertyKey] = propertyValue
        break
      }
    }
    store.updateStore()
  },
  updateSimulationMaindataProperty: (
    propertyKey,
    propertyValue,
    simulationId,
  ) => {
    if (store.simulationMaindata[simulationId]) {
      store.simulationMaindata[simulationId][propertyKey] = propertyValue
      store.updateStore()
    }
  },
  updateStepFunctionsInUse: (funcName, simulationId, isDeletedStep) => {
    for (let i = 0; i < store.simulations.length; i++) {
      if (store.simulations[i]["_id"] == simulationId) {
        if (!isDeletedStep) {
          // function has been selected
          let numOfOccurances = store.simulations[i]?.functionsInUse?.find(
            (func) => func.name === funcName,
          )?.numOfOccurances
          numOfOccurances =
            numOfOccurances || numOfOccurances === 0 ? numOfOccurances + 1 : 1
          store.simulations[i].functionsInUse =
            store.simulations[i]?.functionsInUse?.filter(
              (func) => func.name !== funcName,
            ) || []
          let newFunc = { name: funcName, numOfOccurances }
          store.simulations[i].functionsInUse = [
            ...store.simulations[i].functionsInUse,
            newFunc,
          ]
        } else {
          // step has been removed
          store.simulations[i].functionsInUse =
            store.simulations[i].functionsInUse?.map((func) => {
              if (func.name === funcName) {
                func.numOfOccurances -= 1
              }
              return func.numOfOccurances > 0 ? func : null
            }) || []
          store.simulations[i].functionsInUse =
            store.simulations[i].functionsInUse?.filter((func) => !!func) || []
        }
      }
    }
    store.updateStore()
  },
  // loadingSimulations: false,
  // loadingSimulationsError: '',
  getSelectedSimulationByte32ListArr: () => {
    let arr = []
    let obj = store.getSelectedSimulationByte32ListObj();
    if (obj) {
      for (var i in obj) {
        arr.push({ hash: i, name: obj[i] })
      }
    }
    return arr
  },
  getSelectedSimulationAddressListArr: () => {
    var arr = []
    var obj = store.getSelectedSimulationAddressListObj()
    for (var i in obj) {
      arr.push({ address: i, name: obj[i] })
    }
    return arr
  },
  shortenedAddress: (address) => {
    return address?.slice?.(0, 4) + "..." + address?.slice?.(-2)
  },
  shortenedByte32: (hash) => {
    if (hash) {
      return `${hash.substring(0, 7)}...${hash.substring(hash.length - 7)}`
    } else {
      return ""
    }
  },
  copyReviewRelatedSimulations: async (body) => {
    try {
      let url = "/review/copy-simulation"
      return await requestJSON("POST", url, body)
    } catch (err) {
      console.log(
        "Some error has occured while copying review related simulations ",
        err,
      )
    }
  },
  copyFromTemplate: async (body) => {
    try {
      let url = "/review/copy-from-template"
      return await requestJSON("POST", url, body)
    } catch (err) {
      console.log("Some error has occured while copying from template ", err)
    }
  },
  getChatResponseFromSystem: async (body) => {
    try {
      let url = "/review/get-chat-response-from-system"
      return await requestJSON("POST", url, body)
    } catch (err) {
      console.log("Some error has occured while getting response from system ", err)
    }
  },
  createReview: async (reviewData) => {
    if (window["config"].SKIP_DB) {
      store.allMyReviews.unshift({
        _id: store.myReviews.length + 1,
        name: reviewData.name,
        engagemenHeaderId: reviewData.enagement_id,
        description: reviewData.description,
      })
      store.myReviews.unshift({
        _id: store.myReviews.length + 1,
        name: reviewData.name,
        engagemenHeaderId: reviewData.enagement_id,
        description: reviewData.description,
      })
      localStorage.setItem("my-reviews", JSON.stringify(store.myReviews))
      store.currentReviewId = (store.myReviews.length + 1).toString()
    } else {
      try {
        let url = "/review/my-review"
        const reviewResponse = await requestJSON("POST", url, reviewData)
        store.currentReviewId = reviewResponse.reviewId
        await store.updateMyReviewList()
      } catch (err) {
        console.log("Some error has occured while saving review ", err)
        store.currentReviewId = ""
      }
    }
    store.updateStore()
  },
  fetchtMyReviews: async () => {
    if (window["config"].SKIP_DB) {
      let reviewList = localStorage.getItem("my-reviews")
      store.allMyReviews = reviewList ? JSON.parse(reviewList) : []
      store.myReviews = reviewList ? JSON.parse(reviewList) : []
      store.updateStore()
    } else {
      try {
        let url = "/review/my-reviews"
        let myReviews = await requestJSON("GET", url, undefined, true)
        store.allMyReviews = myReviews
        store.myReviews = myReviews
      } catch (err) {
        console.log("Some error has occured while fetching my reviews ", err)
      } finally {
        store.updateStore()
      }
    }
  },
  onEditReviewFilesClose: (review_id) => {
    store.invalidateReviewAbiCache(review_id)
    store.allSimulations = []
    store.simulations = []
    store.simulationMaindata = {}
    store.preFetchedReviewId = ""
    store.updateStore()
    store.clearOneSimulationData()
  },
  onDefineDefaultStepClick: async (
    REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS,
    defaultStepSimulationId,
    review_id,
    engagement_id,
  ) => {
    let newSimulationId = null
    if (defaultStepSimulationId) {
      newSimulationId = defaultStepSimulationId
    } else {
      newSimulationId = await store.newSimulation(
        {
          name: "Default simulation",
          public: !REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS,
          engagement_id: engagement_id,
          review_id: review_id,
        },
        null,
        false,
        true,
      )
      let reqBody = {
        simulationId: newSimulationId,
        reviewId: review_id,
      }
      store.selectedReviewData["defaultStepSimulationId"] = newSimulationId
      store.updateStore()
      store.addDefaultStepSimulationId(reqBody)
    }
    navigate(
      getSimulationURL({
        simulationId: newSimulationId,
        engagement_id: engagement_id,
        review_id: review_id,
      }),
    )
  },
  updateMyReviewList: async () => {
    let url = "/review/my-reviews"
    invalidateCache("GET", url, undefined)
    await store.fetchtMyReviews()
  },
  changePinReviewStatus: (value, review_id) => {
    store.updateReview("isPinned", value, review_id)
  },
  fetchPinnedReviews: async () => {
    try {
      let url = "/review/pinned-reviews"
      let pinnedReviews = await requestJSON("GET", url, undefined, false)
      if (!Array.isArray(pinnedReviews)) {
        console.log("pinned reviews in not an array")
      }
      store.pinnedReviews = pinnedReviews
    } catch (err) {
      console.log("Some error has occured while fetching pinned reviews ", err)
    } finally {
      store.updateStore()
    }
  },
  fetchtCiReviews: async (reviewId) => {
    try {
      let url = "/review/ci-reviews/" + reviewId
      let ciReviews = await requestJSON("GET", url, undefined, true)
      store.ciReviews = ciReviews
    } catch (err) {
      console.log("Some error has occured while fetching ci reviews ", err)
    } finally {
      store.updateStore()
    }
  },
  fetchOneReview: async (reviewId) => {
    try {
      let url = "/review/my-review/" + reviewId
      let reviewData = await requestJSON("GET", url, undefined, true)
      return reviewData
    } catch (err) {
      console.log("Some error has occured while fetching one review ", err)
    }
  },
  fetchTemplateList: async () => {
    try {
      let url = "/review/templates"
      let templates = await requestJSON("GET", url)
      store.templates = templates
      store.updateStore()
    } catch (err) {
      console.log("Some error has occured while fetching templates ", err)
    }
  },
  updateCiReviewList: async (reviewId) => {
    store.ciReviews = []
    store.updateStore()
    let url = "/review/ci-reviews/" + reviewId
    invalidateCache("GET", url, undefined)
    await store.fetchtCiReviews(reviewId)
  },
  fetchtAnalytics: async (dateObj) => {
    try {
      let url = "/logger/logs/" + dateObj.start_date + "/" + dateObj.end_date
      let analyticsData = await requestJSON("GET", url)
      store.analytics = analyticsData
      store.allAnalytics = analyticsData
    } catch (err) {
      console.log("Some error has occured while fetching one review ", err)
    } finally {
      store.updateStore()
    }
  },
  exportAnalytics: () => {
    let data = store.analytics.map((item) => {
      return {
        Created: require("moment")(item.created).format("MM-DD-YYYY | hh:mm A"),
        Organization: item["organizationData"]
          ? item.organizationData.name
          : "N/A",
        Engagement:
          item.engagement_name == "Private"
            ? item.engagementData.engId
            : item.engagement_name,
        Review: item.review_name,
        User: item.user_email,
        Operation: item.operation,
        Simulation: item.simulation_name,
      }
    })
    let dataStr = [
      Object.keys(data[0]).join(","),
      ...data.map((row) => Object.values(row).join(",")),
    ].join("\n")
    console.log("dataStr", dataStr)
    downloader(
      dataStr,
      "text/csv",
      "export_" + require("moment")().format("YYYYMMDD_hhmmss") + ".csv",
    )
  },
  deleteReview: async (reviewId) => {
    if (window["config"].SKIP_DB) {
      let reviewIndex = store.myReviews.findIndex((item) => {
        return item._id === reviewId
      })
      store.myReviews.splice(reviewIndex, 1)
      store.allMyReviews.splice(reviewIndex, 1)
      localStorage.setItem("my-reviews", JSON.stringify(store.myReviews))
    } else {
      try {
        let url = "/review/my-review/" + reviewId
        await requestJSON("DELETE", url)
        let reviewIndex = store.myReviews.findIndex((item) => {
          return item._id === reviewId
        })
        store.myReviews.splice(reviewIndex, 1)
        store.allMyReviews.splice(reviewIndex, 1)
      } catch (err) {
        console.log("Some error has occured while fetching my reviews ", err)
      }
    }
    store.updateStore()
  },
  updateReview: async (fieldName, value, reviewId) => {
    if (window["config"].SKIP_DB) {
      let reviewIndex = store.myReviews.findIndex((item) => {
        return item._id === reviewId
      })
      store.myReviews[reviewIndex][fieldName] = value
      store.allMyReviews[reviewIndex][fieldName] = value
      localStorage.setItem("my-reviews", JSON.stringify(store.myReviews))
    } else {
      try {
        let url = "/review/my-review/" + reviewId
        let body = {
          [fieldName]: value,
        }
        await requestJSON("PUT", url, body)
        let oneReviewUrl = "/review/my-review/" + reviewId
        await invalidateCache("GET", oneReviewUrl, undefined)
        await store.updateMyReviewList()
        await store.fetchPinnedReviews()
      } catch (err) {
        console.log("Some error has occured while updating review ", err)
      }
    }
    store.updateStore()
  },
  createEngagement: async (engagementData) => {
    try {
      let url = "/engagement/engagement"
      await requestJSON("POST", url, engagementData)
      await store.updateEngagementList()
    } catch (err) {
      console.log("Some error has occured while saving engagement ", err)
    } finally {
      store.updateStore()
    }
  },
  fetchEngagements: async () => {
    try {
      let url = "/engagement/engagements"
      let engagements = await requestJSON("GET", url, undefined, true)
      store.engagements = engagements
      store.allEngagements = engagements
    } catch (err) {
      console.log("Some error has occured while fetching engagements ", err)
    } finally {
      store.updateStore()
    }
  },
  updateEngagementList: async () => {
    store.engagements = []
    store.updateStore()
    let url = "/engagement/engagements"
    invalidateCache("GET", url, undefined)
    await store.fetchEngagements()
  },
  fetchUserEngagements: async () => {
    try {
      let url = "/engagement/userEngagements"
      let engagements = await requestJSON("GET", url)
      store.userEngagements = engagements
    } catch (err) {
      console.log(
        "Some error has occured while fetching user engagements ",
        err,
      )
    } finally {
      store.updateStore()
    }
  },
  checkIsReviewAllowed: async (email) => {
    try {
      let url = "/engagement/isUserAllowed"
      let isReviewAllowedResponse = await requestJSON("POST", url, {
        email: email,
      })
      store.isReviewAllowed = isReviewAllowedResponse
    } catch (err) {
      console.log("Some error has occured while fetching isAllowed ", err)
    } finally {
      store.updateStore()
    }
  },
  updateEngagement: async (engagementData, engagementId) => {
    try {
      let url = "/engagement/engagement/" + engagementId
      await requestJSON("PUT", url, engagementData)
      await store.updateEngagementList()
    } catch (err) {
      console.log("Some error has occured while updating engagement ", err)
    } finally {
      store.updateStore()
    }
  },
  checkEngagementManagerAccess: async () => {
    try {
      let url = "/engagement/checkEngagementManagerAccess"
      let hasEngagementManagerAccess = await requestJSON("GET", url)
      store.hasEngagementManagerAccess = hasEngagementManagerAccess
    } catch (err) {
      console.log(
        "Some error has occured while checking engagement manager status ",
        err,
      )
    } finally {
      store.updateStore()
    }
  },
  createOrganization: async (organizationData) => {
    try {
      let url = "/organization/organization"
      await requestJSON("POST", url, organizationData)
      await store.updateOrganizationList()
    } catch (err) {
      console.log("Some error has occured while saving organization ", err)
    } finally {
      store.updateStore()
    }
  },
  fetchOrganizations: async () => {
    try {
      let url = "/organization/organizations"
      let organizations = await requestJSON("GET", url, undefined, true)
      store.organizations = organizations
    } catch (err) {
      console.log("Some error has occured while fetching organizations ", err)
    } finally {
      store.updateStore()
    }
  },
  updateOrganizationList: async () => {
    store.organizations = []
    store.updateStore()
    let url = "/organization/organizations"
    invalidateCache("GET", url, undefined)
    await store.fetchOrganizations()
  },
  updateOrganization: async (organizationData, organizationId) => {
    try {
      let url = "/organization/organization/" + organizationId
      await requestJSON("PUT", url, organizationData)
      await store.updateOrganizationList()
    } catch (err) {
      console.log("Some error has occured while updating organization ", err)
    } finally {
      store.updateStore()
    }
  },
  checkIsAdmin: async () => {
    try {
      let url = "/organization/checkIsAdmin"
      let isAdmin = await requestJSON("GET", url)
      store.isAdmin = isAdmin
    } catch (err) {
      console.log("Some error has occured while checking is admin status ", err)
    } finally {
      store.updateStore()
    }
  },
  fetchUserOrganizations: async () => {
    try {
      let url = "/organization/userOrganizations"
      let organizations = await requestJSON("GET", url)
      store.userOrganizations = organizations
    } catch (err) {
      console.log(
        "Some error has occured while fetching user organizations ",
        err,
      )
    } finally {
      store.updateStore()
    }
  },
  showToaster: (variant, message) => {
    store.toaster.open = true
    store.toaster.variant = variant
    store.toaster.message = message
    store.updateStore()
  },
  hideToaster: () => {
    store.toaster.open = false
    store.toaster.variant = null
    store.toaster.message = ""
    store.updateStore()
  },
  isMetaMaskConnectedToApp: () => {
    return !!window?.ethereum?.selectedAddress
  },
  getStoryId: () => {
    let params = new URLSearchParams(location.search)
    let storyId = params.get("id")
    if (!storyId) {
      //@ts-ignore
      storyId = store.currentStoryId
    }
    return storyId
  },
  removeSimulationById: async (simulationId, user) => {
    try {
      let deleteResponse = await requestJSON(
        "DELETE",
        "/simulation/" + simulationId,
      )
      if (deleteResponse && deleteResponse["success"]) {
        let newSimulationList = store.simulations.filter(
          (item) => item._id != simulationId,
        )
        store.simulations = newSimulationList
        let newAllSimulationList = store.allSimulations.filter(
          (item) => item._id != simulationId,
        )
        store.allSimulations = newAllSimulationList
        delete store.simulationMaindata[simulationId]
        store.updateStore()
        if (qs().review_id) {
          store.updateSidWhenRemove()
        }
      }
    } catch (err) {
      console.log("Some error has occured while deleting simulation ", err)
    }
  },
  fetchDefaultStepSimulationData: async () => {
    try {
      let reviewData = store.selectedReviewData

      if (!reviewData["defaultStepSimulationId"]) {
        store.isDefaultSimulation = false
        return
      }
      if (reviewData["defaultStepSimulationId"]) {
        let defaultStepSimulationData = await requestJSON(
          "GET",
          "/simulation/" + reviewData["defaultStepSimulationId"],
        )
        store.defaultSimulationData = defaultStepSimulationData
      }
    } catch (err) {
      console.log(
        "Some error has occured while fetching default step simulation data ",
        err,
      )
    } finally {
      store.updateStore()
    }
  },
  addDefaultSimulationData: async () => {
    if (
      store.selectedReviewData["defaultStepSimulationId"] &&
      store.selectedSimulationData._id !=
        store.selectedReviewData["defaultStepSimulationId"]
    ) {
      if (
        store.defaultSimulationData["steps"] &&
        store.defaultSimulationData["steps"].length
      ) {
        for (let i = 0; i < store.defaultSimulationData["steps"].length; i++) {
          store.defaultSimulationData["steps"][i]["defaultStep"] = true
        }
        let newSteps = store.defaultSimulationData.steps.concat(store.steps)
        store.steps = newSteps
        store.isDefaultSimulation = false
        store.updateStore()
      }
    }
  },
  updateOneSimulation: async (simulationId, updateObj) => {
    // Guard against transient/placeholder ids (0, undefined, "") so we don't
    // hit /simulation/0 and generate a spurious 401 Simulation.Update audit.
    if (!simulationId || !/^[a-f\d]{24}$/i.test(String(simulationId))) return
    if (!updateObj || Object.keys(updateObj).length === 0) return
    try {
      // Return whatever the server responded so callers can detect no-op saves.
      return await requestJSON("PUT", "/simulation/" + simulationId, updateObj)
    } catch (err) {
      console.log("Some error has occured while updating simulation ", err)
    }
  },
  latestBlock: null,
  getLatestBlock: async () => {
    if (store.latestBlock) {
      return store.latestBlock
    } else {
      try {
        let response = await requestJSON("GET", "/get-block?number=latest")
        store.latestBlock = response
        return response
      } catch (err) {
        console.log(
          "Some error has occured while fetching latest block id ",
          err,
        )
      } finally {
        store.updateStore()
      }
    }
  },
  setAddressList: () => {
    if (
      store.selectedSimulationData &&
      !store.selectedSimulationData.addressList
    ) {
      store.selectedSimulationData.addressList = {}
    }
    // if(store.selectedSimulationData.hasOwnProperty('steps')) {
    //   store.selectedSimulationData.steps.forEach((item, index) => {
    //     if(item.hasOwnProperty('deployedAddress') && item.deployedAddress) {
    //       store.selectedSimulationData.addressList[item.deployedAddress] = 'Smart contract that delpoyed in step #'+(index+1);
    //     }
    //   });
    // }
    store.selectedSimulationAddressList =
      store.selectedSimulationData.addressList
  },
  setByte32List: () => {
    if (
      store.selectedSimulationData &&
      !store.selectedSimulationData["byte32List"]
    ) {
      store.selectedSimulationData.byte32List = {}
    }
    // if(store.selectedSimulationData.hasOwnProperty('steps')) {
    //   store.selectedSimulationData.steps.forEach((item, index) => {
    //     if(item.hasOwnProperty('deployedAddress') && item.deployedAddress) {
    //       store.selectedSimulationData.addressList[item.deployedAddress] = 'Smart contract that delpoyed in step #'+(index+1);
    //     }
    //   });
    // }
    store.selectedSimulationByte32List = store.selectedSimulationData.byte32List
  },
  removeFilesIfNotRelyingOnReviewFiles: () => {
    if (store.steps.length) {
      for (let i = 0; i < store.steps.length; i++) {
        if (
          store.steps[i].type === "COMPILE_SMART_CONTRACT" &&
          store.steps[i].using_review_files
        ) {
          store.steps[i].files = []
        }
      }
      store.updateStore()
    }
  },
  saveStory: async () => {
    store.removeFilesIfNotRelyingOnReviewFiles()

    let storyId = store.getStoryId()

    // //check if any changes
    let dataChanged = true

    // if (store.selectedSimulationData) {
    //   if (JSON.stringify(store.selectedSimulationData['results']) == JSON.stringify(store.results) && JSON.stringify(store.selectedSimulationData['steps']) == JSON.stringify(store.steps)) {
    //     dataChanged = false;
    //   }
    // }

    let stepsWithoutDefaultSteps = JSON.parse(
      JSON.stringify(store.steps),
    ).filter((step) => !step.defaultStep)

    // Strip UI-only properties from steps before saving to DB
    stepsWithoutDefaultSteps.forEach((step) => {
      delete step.collapsed
      delete step.abiLoadingStatus
      delete step.currentDeps
    })

    // Check all steps and all
    if (dataChanged) {
      let saveObj = {
        results: store.results,
        steps: stepsWithoutDefaultSteps,
        _id: storyId,
        network: store.network,
        isMainnet: store.isMainnet,
        // Include byte32List so a byte32-only change still triggers a save,
        // and so it rides along in the single PUT below (one audit per save).
        byte32List: store.selectedSimulationData?.["byte32List"],
      }
      let lastSavedStoryCache = window["lastSavedStoryCache"]
      if (
        storyId
        // && store.steps?.length > 0 allow saving simulation without steps.
        // Fixing the bug that cannot reset initilization steps.
      ) {
        if (lastSavedStoryCache != JSON.stringify(saveObj)) {
          try {
            var results = require("lodash").cloneDeep(store.results)
            if (results && results[0]) {
              delete results?.[0]?.steps
            }

            const updateResp = await store.updateOneSimulation(storyId, {
              steps: stepsWithoutDefaultSteps,
              results,
              byte32List: store.selectedSimulationData?.["byte32List"],
            })
            window["lastSavedStoryCache"] = JSON.stringify(saveObj)

            if (
              store.selectedSimulationData._id !=
              store.selectedReviewData["defaultStepSimulationId"]
            ) {
              store.updateSimulationMetadataProperty(
                "numOfSteps",
                store.steps.length,
                storyId,
              )
              store.updateSimulationMetadataProperty(
                "modified",
                new Date().valueOf(),
                storyId,
              )
              store.updateSimulationMetadataProperty(
                "functionsInUse",
                store.getFunctionInUseFromSteps(stepsWithoutDefaultSteps),
                storyId,
              )

              store.updateSimulationMaindataProperty(
                "steps",
                stepsWithoutDefaultSteps,
                storyId,
              )
              store.updateSimulationMaindataProperty(
                "results",
                store.results,
                storyId,
              )

              // add sid
              if (qs().review_id) {
                store.updateSidWhenSave()
              }
            }
            // for default simulation
            if (
              store.selectedSimulationData._id ===
              store.selectedReviewData["defaultStepSimulationId"]
            ) {
              store.updateSimulationMaindataProperty(
                "steps",
                store.steps,
                storyId,
              )
              store.updateSimulationMaindataProperty(
                "results",
                store.results,
                storyId,
              )
            }

            //fetching default simulation steps if changes is done in default simulation
            if (
              store.selectedReviewData["defaultStepSimulationId"] &&
              store.selectedSimulationData._id ==
                store.selectedReviewData["defaultStepSimulationId"]
            ) {
              await store.fetchDefaultStepSimulationData()
              store.fetchSimulationListMetadata(true)
            }

            store.createLog({
              simulationId: storyId,
              operation: "Save",
              // Server signals updateOne matched but didn't modify → suppress audit noise.
              skipIfNoop: !!(updateResp && updateResp.noop),
            })
            store.updateStore()
          } catch (err) {
            console.log("save does not work")
          }
        }
      }
    }
  },
  updateSidWhenRemove: () => {
    let max = 0
    let simulationsCopy = JSON.parse(JSON.stringify(store.allSimulations))

    simulationsCopy.reverse()

    for (let sim of simulationsCopy) {
      max++
      sim.sid = max
    }
    simulationsCopy.reverse()
    store.allSimulations = simulationsCopy
    store.simulations = simulationsCopy
    store.updateStore()
  },
  updateSidWhenSave: () => {
    let max = 0
    let simulationsCopy = JSON.parse(JSON.stringify(store.allSimulations))
    for (let sim of simulationsCopy) {
      if (sim.sid) {
        if (sim.sid > max) {
          max = sim.sid
        }
      }
    }
    for (let sim of simulationsCopy) {
      if (!sim.sid) {
        max++
        store.updateSimulationMetadataProperty("sid", max, sim._id)
        store.updateSimulationMaindataProperty("sid", max, sim._id)
      }
    }
  },
  getFunctionInUseFromSteps: (steps) => {
    if (steps.length) {
      let functionsInUseObj = {}

      steps.forEach((step) => {
        // eslint-disable-next-line no-prototype-builtins
        if (step.hasOwnProperty("function_name") && step.function_name) {
          functionsInUseObj[step.function_name] = functionsInUseObj[
            step.function_name
          ]
            ? functionsInUseObj[step.function_name] + 1
            : 1
        }
      })

      let functionsInUseArr = []

      Object.keys(functionsInUseObj).forEach((funcName) => {
        let simulationFunc = {
          name: funcName,
          numOfOccurances: functionsInUseObj[funcName],
        }
        functionsInUseArr.push(simulationFunc)
      })

      return functionsInUseArr
    }
  },
  duplicating: false,
  duplicate: async (copySimulationData) => {
    if (store.duplicating) return
    store.duplicating = true
    store.updateStore()
    await store.saveStory()
    try {
      var storyId = store.getStoryId()
        ? store.getStoryId()
        : copySimulationData.storyId
      let newSimulationData = await requestJSON(
        "PUT",
        "/simulation/" + storyId + "/duplicate",
        copySimulationData,
      )
      if (copySimulationData.stayInSamePage) {
        newSimulationData["functionsInUse"] = copySimulationData.functionsInUse
        newSimulationData["numOfSteps"] = copySimulationData.numOfSteps
      } else if (newSimulationData && newSimulationData["_id"]) {
        store.history.push(
          getSimulationURL({ simulationId: newSimulationData["_id"] }),
        )
      }
      store.duplicating = false
      store.allSimulations.unshift(newSimulationData)
      store.simulations.unshift(newSimulationData)
      // add sid
      if (qs().review_id) {
        store.updateSidWhenSave()
      }
      store.updateStore()
    } catch (err) {
      console.log("Some error has occured while duplicating simulation ", err)
    }
  },
  clickUser: (value) => {
    // setSearchQuery('')
    store.history.push(getLibraryURL({ user: value }))
  },
  limitTags: (allTags) => {
    let tags = []
    if (allTags && allTags.length) {
      if (allTags.length > 3) {
        tags = allTags.slice(0, 3).map((tag) => {
          return {
            name: tag,
            readOnly: false,
          }
        })
        tags.push({
          name: "+" + (allTags.length - 3).toString(),
          readOnly: true,
        })
      } else {
        tags = allTags.map((tag) => {
          return {
            name: tag,
            readOnly: false,
          }
        })
      }
    }

    return tags
  },
  clickTag: (value) => {
    store.history.push(consts.SCR_APP_URLS.library + "?tag=" + value)
  },
  newSimulation: async function newSimulation(
    defaults = undefined,
    en,
    redirectToNewSimualation = true,
    isDefaultSimulation = false,
  ) {
    store.duplicating = true
    store.updateStore()
    let newSimulationData = await requestJSON("PUT", "/simulation", {
      defaults,
    })

    if (newSimulationData["_id"] && redirectToNewSimualation) {
      store.history.push(
        getSimulationURL({ simulationId: newSimulationData["_id"] }),
      )
    }
    store.duplicating = false
    //Do not add default simulation in the list
    if (!isDefaultSimulation) {
      store.allSimulations.unshift(newSimulationData)
      store.updateStore()
    }
    return newSimulationData["_id"]
  },
  download: () => {
    //@ts-ignore
    var listOfFields = StepResultTable({ textOnly: true })
    downloader(
      listOfFields.map((x) => x.title).join(",") +
        "\n" +
        // Sections (couple of rows) -For each block that tested
        store.results
          .map((result) => {
            var str
            str =
              "------------\nBlock " +
              result.steps_output?.[0]?.blockNumber +
              "\n"

            // Rows - for each step
            str += result.steps_output
              .map((output, index) => {
                var step = store.steps[index]
                var td = StepResultTable({
                  blockNumber: output.blockNumber,
                  step,
                  textOnly: true,
                  store,
                })

                // Cells - for each field in one step.
                return td
                  .map((field) => field.value(step, output))
                  .map((x) =>
                    x === undefined
                      ? ""
                      : '"' + String(x).replace(/"/g, '""') + '"',
                  )
                  .join(",")
              })
              .join("\n")
            return str
          })
          .join("\n\n"),

      "text/csv",

      "export_" + require("moment")().format("YYYYMMDD_hhmmss") + ".csv",
    )
  },
  downloadStoryJSON: (thisId) => {
    var storyInList = store.stories.find((x) => x._id == thisId)
    downloader(
      JSON.stringify({
        name: storyInList.name,
        description: storyInList.description,
        environment: storyInList.environment,
        steps: storyInList.steps,
      }),
      "application/json",
      storyInList.name?.replace(/ /g, "_") +
        "_" +
        require("moment")().format("YYYYMMDD_hhmmss") +
        ".json",
    )
  },
  downloadStoryZip: () => {
    /**
    downloader(
      JSON.stringify({
        name: story.name,
        description: story.description,
        environment: story.environment,
        steps: store.steps
      }),
      "application/json",
      "scr-" + store.steps.length + "-steps.json",
    )
    */
  },
  createLog: async (data) => {
    try {
      let url = "/logger/create-log"
      let logResponse = await requestJSON("POST", url, data)
    } catch (err) {
      console.log("Some error has occured while creating log ", err)
    }
  },
  selectedAddress: () => {
    return window?.ethereum?.selectedAddress
  },
  isMainnet: false,
  simulatorTest: async (storyDetails = {}) => {
    store.results = []
    store.isLoadingResults = true
    store.viewOrEdit = "result"
    store.currentResult = 0
    store.updateStore()

    var from, to
    from = to = store.blockNumber
    if (store.blockNumberMode != "latest") {
      if (String(store.blockNumber).match(/-/)) {
        from = Number(String(store.blockNumber).replace(/-.*/, ""))
        to = Number(String(store.blockNumber).replace(/.+-/, ""))
      }
    }
    /** @type {import("../../backend/interfaces").CustomTestRequest} */
    var x = {
      test: {
        steps: store.steps,
      },
      ...storyDetails,
      network: store.network,
      isMainnet: store.isMainnet,
      blockNumber: store.blockNumber,
      blockNumberMode: store.blockNumberMode || "latest",
    }
    try {
      store.results = []
      store.updateStore()
      if (store.blockNumberMode != "manual") {
        from = to = 1
      }
      for (var i = from; i <= to; i++) {
        var result =
          (await requestJSON("POST", "/custom-test", {
            // ...x,
            storyId: store.getStoryId(),
            reviewId: qs().review_id,
          })) || {}
        store.latestBlock = result.latestBlock
        store.results.push({
          blockNumber: i,
          ...result,
        })
        store.updateSimulationMetadataProperty(
          "pass_expections",
          result?.pass_expections,
          store.getStoryId(),
        )
        store.updateStore()
      }

      store.isLoadingResults = false
      store.updateStore()
    } catch (err) {
      console.log(err)
      store.isLoadingResults = false
      store.updateStore()
      return
    }
  },
  /** @type {import("../../backend/interfaces").Step[]}*/
  steps: [],
  leftWidth: 0,
  showStudioBanner: true,
  selectedStep: 0,
  colapseAll: (flag) => {
    for (var i of store.steps) {
      i.collapsed = flag
    }
    store.updateStore()
  },
  /** @type {{open,message,variant}[]}*/
  snackBars: [],
  addSnackBarMsg: (
    message = "Something went wrong. Please try again.",
    variant = "error",
  ) => {
    store.snackBars.push({
      open: true,
      message,
      variant,
    })
    store.updateStore()
  },
  isIFavorited: async ({ storyId }) => {
    return false
  },
  clearStory: () => {
    store.steps = []
    // store.selectedStep=-1
    store.results = []
    store.updateStore()
  },
  results: null,
  addresses: {},
  /** @type {{createdAt?,name?,description?,environment?,organization?,user?,userName?,_id?, steps:[]}[]}*/
  stories: [],

  /** @type {{createdAt?,name?,description?,environment?,organization?,user?,userName?,_id?,steps?:[]}}*/
  draft: undefined,

  /** @type {number|"new"|"import"}*/
  editingStory: undefined,

  /** @type {number}*/
  deletingStory: undefined,

  /** @type {boolean} */
  isDryRun: true,

  /** @param thisId {number|"new"|"import"}*/
  startEditing: (thisId) => {
    store.editingStory = thisId
    if (thisId == "new" || thisId == "import") {
      store.draft = {
        name: "Untitled Story",
        description: "",
        environment: "",
      }
    } else {
      var storeInList = store.stories.find((x) => x._id == thisId)
      if (storeInList) {
        // we probably in the stories list table.
        store.draft = { ...storeInList }
      } else {
        // we probably in one store editing (steps page), and probably we don't have the story array
        store.draft = {
          name: store.name,
          description: store.description,
          environment: store.environment,
        }
      }
    }
    store.updateStore()
  },

  history: undefined,
  saveField: async (key) => {
    const params = new URLSearchParams(location.search)
    const storyId = params.get("id")
    await requestJSON("PUT", "/story", {
      [key]: store[key],
      _id: storyId,
    })
  },

  saveDraftStory: async () => {
    var currentId = store.editingStory
    store.name = store.draft.name
    store.description = store.draft.description
    store.environment = store.draft.environment
    if (currentId == "new") {
      var postResonse = await requestJSON("POST", "/story", {
        name: store.draft.name,
        description: store.draft.description,
        environment: store.draft.environment,
        _id: currentId,
        steps: store.draft.steps || [],
      })
      if (postResonse?._id) {
        postResonse.success = true
        currentId = postResonse._id
      }
      store.history.push(`/story?id=${postResonse?._id}`)
      store.addSnackBarMsg(
        "New story " + store.draft.name + " successfully created",
        "success",
      )
      store.editingStory = undefined
      return
    } else {
      postResonse = await requestJSON("PUT", "/story", {
        name: store.draft.name,
        description: store.draft.description,
        environment: store.draft.environment,
        _id: currentId,
      })
    }
    if (postResonse?.success) {
      store.addSnackBarMsg(
        `Story '${store.draft.name}' successfully updated.`,
        "success",
      )
      var befStore = store.stories.find((x) => x._id == store.editingStory)
      if (befStore) {
        befStore.name = store.draft.name
        befStore.description = store.draft.description
        befStore.environment = store.draft.environment
      }
      store.editingStory = undefined
    } else {
      store.addSnackBarMsg(`Failed to update '${store.draft.name}'.`, "error")
    }
    store.updateStore()
  },

  startDeleting: (thisId) => {
    store.deletingStory = thisId
    store.updateStore()
  },

  deleteStoryConfirmed: async () => {
    const _id = store.deletingStory
    store.stories.splice(
      store.stories.findIndex((x) => x._id == _id),
      1,
    )
    await requestJSON("DELETE", "/story", { _id })
    store.addSnackBarMsg(`Story successfully deleted`, "success")
    store.updateStore()
  },

  closeEditing: () => {
    store.editingStory = undefined
    store.updateStore()
  },
  getDeployedByCode: async (data) => {
    var {compilerSettings,files,mainContract,mainFile,compilerVersion}=data
    try {
      if(compilerSettings && !compilerSettings.viaIR) {
        delete compilerSettings.viaIR
      }
      return await requestJSON("POST", "/get-deployed-code", {
        files,
        mainContract,
        mainFile,
        compilerVersion,
        compilerSettings
      })
    } catch (err) {
      console.log("Some error has occured while fetching abi ", err)
    }
  },
  getAbi: async (data) => {
    try {
      let compiledData = await getCompiledMemoized({
        files: data.files,
        mainContract: data.mainContract,
        mainFile: data.mainFile,
        compilerVersion: data.compilerVersion,
        compilerSettings: data.compilerSettings,
      })

      if (!compiledData || compiledData?.errors) {
        return ""
      } else {
        return compiledData
      }
    } catch (err) {
      console.log("Some error has occured while fetching abi ", err)
    }
  },

  getBytecodeFromEtherscan: async (contractAddress, blockNumber) => {
    try {
        let response = await requestJSON("GET", "/get-etherscan-byte-code?contractAddress="+contractAddress)
        return response;
    } catch (err) {
      console.log("Some error has occured while fetching bytecode from etherscan ", err)
    }
  },

  abiABiUseUsingIt: async (stepIndex) => {
    for (var i = 0; i < store.steps.length; i++) {
      // Search for the deployment step of this step.
      if (i == stepIndex) continue // skip current step
      if (store.steps[i].to == store.steps[stepIndex].deployedAddress) {
        store.steps[i].abi = store.steps[stepIndex].abi
      }
    }
  },
  isStepReadOnly: (stepIndex) => {
    var isLoggedIn = store.getUser()
    if (store.isReadOnly) return true
    return (
      !isLoggedIn ||
      !store.userIsAllowed(isLoggedIn?.email) ||
      store.isReadOnly ||
      store.steps[stepIndex]["defaultStep"]
    )
  },

  loadingUser: null,
  getUserPlain: null,
  getUser: () => {
    if (store.getUserPlain) {
      return store.getUserPlain
    }
    if (store.loadingUser) {
      return null
    }
    store.loadingUser = true
    requestJSON("GET", "/user", null, true).then((x) => {
      store.getUserPlain = x
      store.loadingUser = false
      store.updateStore()
    })
  },
  compileStepFilesChanged: async (stepIndex) => {
    var step = store.steps[stepIndex]
    if (!step.mainContract) {
      // return
    }
    if (step.type != "COMPILE_SMART_CONTRACT") return

    if (step["files"] && !step.files.length) {
      step.abiLoadingStatus = "ready"
      step.abi = []
      step.bytecode = ""
      step.compiling = false
      store.abiABiUseUsingIt(stepIndex)
      store.updateStore()
      return
    }

    step.abiLoadingStatus = "loading"
    if (step.compilationErrors) {
      delete step.compilationErrors
    }
    step.compiling = true
    store.updateStore()
    var compiled = await getCompiledMemoized({
      files: step.files,
      mainContract: step.mainContract,
      mainFile: step.mainFile,
      compilerVersion: step.compilerVersion,
      compilerSettings: step.compilerSettings,
    })
    step.compiling = false
    var abi = compiled?.abi
    var bytecode = compiled?.bytecode
    if (compiled?.errors) {
      step.compilationErrors = compiled.errors
      step.abiLoadingStatus = "error"
      store.updateStore()
      return
    }
    if (!compiled) return
    step.abiLoadingStatus = "ready"
    step.abi = abi
    step.bytecode = bytecode
    // updateData()

    store.abiABiUseUsingIt(stepIndex)

    store.updateStore()
  },
  loadPrints: async () => {
    if (store.loadForPrinter) return // do not load twice before finish the last one
    store.loadForPrinter = true
    store.updateStore()
    store.simulationListForPrint = store.getSimluationList(true)
    store.loadForPrinter = false
    store.updateStore()
  },
  doPrint: async () => {
    var newQs = updateQs({
      print: "yes",
    })
    store.history.push("?" + newQs)
    store.updateStore()
  },
  reRunSimulations: async () => {
    try {
      for (var sim of store.simulations) {
        if (store.selectedSimulationList[sim["_id"]]) {
          delete sim.pass_expections
          sim.loading_expections = true
          store.updateStore()
          var res = await requestJSON("POST", "/custom-test", {
            storyId: sim._id,
            reviewId: qs().review_id,
          })
          await delay(200) // To feel it is working
          sim.loading_expections = false
          sim.pass_expections = res.pass_expections
          store.updateStore()
        }
      }
      await delay(100) // last delay to update the UI. Alert is blocking ui updates.
      store.showToaster("info", "Re-run successful.")
    } catch (err) {
      store.showToaster(
        "error",
        "Some error has occured while re-running simulations.",
      )
      console.log("Some error has occured while re-running simulations ", err)
    }
  },
  getView: () => {
    /** @type{""|"oneside"} */
    var x = localStorage.view || ""
    // return x
    return "oneside"
  },
  /** @param newView {""|"oneside"} */
  setView: (newView) => {
    localStorage.view = newView
    store.updateStore()
  },
  loadForPrinter: false,
  simulationListForPrint: null,
  createNewSimulation: async (
    isLoggedIn,
    REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS,
  ) => {
    if (!isLoggedIn) {
      location.href = window["config"].AUTH_UI
      return
    }

    if (qs().engagement_id) {
      return await store.newSimulation({
        public: !REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS,
        engagement_id: qs().engagement_id,
        review_id: qs().review_id,
      })
    } else {
      return await store.newSimulation({
        public: !REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS,
      })
    }
  },
  getAllSimulationSelectionStatus: () => {
    let allSelected = true
    if (store.simulations.length == 0) return false
    for (let i = 0; i < store.simulations.length; i++) {
      if (!store.selectedSimulationList[store.simulations[i]._id]) {
        allSelected = false
        break
      }
    }
    return allSelected
  },
  getSimluationList: (removeFiles = false) => {
    let simulationsToReturn = []
    let selectedSimulations = Object.keys(store.selectedSimulationList)
    if (selectedSimulations.length) {
      for (let i = 0; i < selectedSimulations.length; i++) {
        let simulationData = null
        if (removeFiles) {
          simulationData = store.removeFiles(
            store.simulationMaindata[selectedSimulations[i]],
          )
        } else {
          simulationData = store.simulationMaindata[selectedSimulations[i]]
        }
        simulationsToReturn.push(simulationData)
      }
    }
    return simulationsToReturn
  },
  removeFiles: (simulation) => {
    let y = JSON.parse(JSON.stringify(simulation))

    if (y.steps) {
      y.steps.forEach((z) => {
        delete z.files
        delete z.bytecode
        // delete z.data
        // delete z.abi
      })
    }
    // @ts-ignore
    if (y.results) {
      y.results.forEach((z) => {
        delete z.steps // we do not need the steps in the results array
        delete z.execution_log
        if (z.steps_output) {
          z.steps_output.forEach((k) => {
            if (k.result) {
              k.result = k.result.slice(0, 300)
            }
            // delete k.receipt
          })
        }
      })
    }
    return y
  },
  backFromPrinting: () => {
    var newQs = updateQs({
      print: "no",
    })
    store.history.push("?" + newQs)
    store.updateStore()
  },
  // for single simulation
  exportSimulationAsJSON: async () => {
    try {
      let simulationData = store.selectedSimulationData
      store.exportDataAsJSON({
        data: JSON.stringify([simulationData]),
        fileName: simulationData.name + ".json",
        fileType: "text/json",
      })
    } catch (err) {
      console.log(
        "Some error has occured while exporting simulation list to JSON ",
        err,
      )
    }
  },
  // for list of simulations
  exportSimulationsAsJSON: async () => {
    try {
      let simulationList = store.getSimluationList()
      store.exportDataAsJSON({
        data: JSON.stringify(simulationList),
        fileName: "simulations.json",
        fileType: "text/json",
      })
    } catch (err) {
      console.log(
        "Some error has occured while exporting simulation list to JSON ",
        err,
      )
    }
  },
  exportDataAsJSON: ({ data, fileName, fileType }) => {
    // Create a blob with the data we want to download as a file
    const blob = new Blob([data], { type: fileType })
    // Create an anchor element and dispatch a click event on it
    // to trigger a download
    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  },
  importSimulationFromJSON: (e) => {
    const fileReader = new FileReader()
    fileReader.readAsText(e.target.files[0], "UTF-8")
    fileReader.onload = async (e) => {
      if (e.target.result) {
        // @ts-ignore
        let simulations = JSON.parse(e.target.result)
        console.log("simulations", simulations)
        if (simulations.length) {
          for (let i = 0; i < simulations.length; i++) {
            const newSimualtionData = {
              ...JSON.parse(JSON.stringify(simulations[i])),
              engagement_id: qs().engagement_id,
              review_id: qs().review_id,
            }
            await store.newSimulation(newSimualtionData, null, false)
          }
          store.fetchSimulationListMetadata()
        }
      }
    }
  },
  addDefaultStepSimulationId: async (data) => {
    try {
      let url = "/review/add-default-simulation-id"
      await requestJSON("POST", url, data)
    } catch (err) {
      console.log(
        "Some error has occured while adding default step simulations id ",
        err,
      )
    } finally {
      store.updateMyReviewList()
    }
  },
  submitAIfeedback: async ({type, feedbackText, AIresponseLiked}) => {
      try {
        let data = {
          type: type,
          liked: AIresponseLiked,
          feedbackText: feedbackText
        }

        if(type === "simulation") {
          data['simulationId'] = store.selectedSimulationData['_id'];
        } else if (type === "askAI"){
          data['reviewId'] = store.selectedReviewData['_id'];
        }

        let url = "/feedback/ai"
        return await requestJSON("POST", url, data);
      } catch (err) {
        return err;
      }

  }
})

store.onBeforeRender((prevStore) => {})
store.onBeforeRender((prevStore) => {
  // if the deployed address changed. update all simulate executing steps
  for (var i = 0; i < store.steps.length; i++) {
    var prevAdddress = prevStore.steps[i]?.deployedAddress
    var newAddress = store.steps[i].deployedAddress
    if (prevAdddress && newAddress && newAddress != prevAdddress) {
      for (var j = 0; j < store.steps.length; j++) {
        if (store.steps[j].to == prevAdddress) {
          store.steps[j].to = newAddress
        }
        if (store.steps[j].parameters) {
          store.steps[j].parameters.map((x) =>
            String(store.steps[j].parameters).replace(prevAdddress, newAddress),
          )
        }
      }
      break
    }
  }
})
export function qs() {
  return require("qs").parse(location.search.slice(1))
}
export function updateQs(obj) {
  let qs = require("qs").parse(location.search.slice(1))
  qs = {
    ...qs,
    ...obj,
  }
  return require("qs").stringify(qs)
}

window["ethereum"]?.on("accountsChanged", function (accounts) {
  store.updateStore()
})

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
// for easily debubgging
window["store"] = store
export default store
